import axiosInstance from "@/api/axiosInstance";
import {
  ReturnEventVouchersRequest,
  ReturnEventVouchersResponse,
} from "./types";

export const returnEventVouchers = async (
  requestData: ReturnEventVouchersRequest,
): Promise<ReturnEventVouchersResponse> => {
  const url = `/api/private/event-checkouts/${requestData.uuid}/return-vouchers`;

  const { uuid, ...payload } = requestData;

  const response = await axiosInstance.post<ReturnEventVouchersResponse>(
    url,
    payload,
  );

  return response.data;
};
